import styles from './DoubleWaveDivider.module.scss';

interface DoubleWaveDividerProps {
  flip?: boolean;
  reverse?: boolean;
}

export default function DoubleWaveDivider({ flip = false, reverse = false }: DoubleWaveDividerProps) {
  const primary = reverse ? 'var(--color-bg-secondary)' : 'var(--color-bg-primary)';
  const secondary = reverse ? 'var(--color-bg-primary)' : 'var(--color-bg-secondary)';

  if (flip) {
    return (
      <div className={`${styles.doubleWave} ${styles.flip}`} aria-hidden="true">
        <svg viewBox="0 0 1440 200" preserveAspectRatio="none">
          <path
            d="M0,160 C360,100 720,200 1080,140 C1260,120 1380,160 1440,150 L1440,0 L0,0 Z"
            fill={secondary}
          />
          <path
            d="M0,60 C360,0 720,100 1080,40 C1260,20 1380,60 1440,50 L1440,0 L0,0 Z"
            fill={primary}
          />
        </svg>
      </div>
    );
  }

  return (
    <div className={styles.doubleWave} aria-hidden="true">
      <svg viewBox="0 0 1440 200" preserveAspectRatio="none">
        <path
          d="M0,40 C360,100 720,0 1080,60 C1260,80 1380,40 1440,50 L1440,200 L0,200 Z"
          fill={primary}
        />
        <path
          d="M0,140 C360,200 720,100 1080,160 C1260,180 1380,140 1440,150 L1440,200 L0,200 Z"
          fill={secondary}
        />
      </svg>
    </div>
  );
}
